import { useState } from "react";

import { CallsService } from "../services/calls.service";

// Signed URLs are time-limited server-side; cache them briefly per call so
// re-expanding a row doesn't re-fetch, mirroring the supplier-logo cache in
// proposalDocumentsContext.tsx.
const SIGNED_URL_CACHE_TTL_MS = 5 * 60 * 1000;
const SIGNED_URL_CACHE = new Map<string, { url: string; expiresAt: number }>();

export const useCallAudio = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [audioUrl, setAudioUrl] = useState<string | null>(null);

  const loadAudio = async (callId: string) => {
    const cached = SIGNED_URL_CACHE.get(callId);
    if (cached && Date.now() < cached.expiresAt) {
      setAudioUrl(cached.url);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const { signed_url } = await CallsService.getSignedAudioUrl(callId);
      SIGNED_URL_CACHE.set(callId, {
        url: signed_url,
        expiresAt: Date.now() + SIGNED_URL_CACHE_TTL_MS,
      });
      setAudioUrl(signed_url);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not retrieve recording.");
    } finally {
      setLoading(false);
    }
  };

  return {
    loadAudio,
    loading,
    error,
    audioUrl,
    reset: () => {
      setAudioUrl(null);
      setError(null);
    },
  };
};
